import { ApolloError, useQuery } from '@apollo/client';

import { Role } from '__generated__/GQL';

import { CompanyUserDocument, CompanyUserQuery } from './companyUserQuery.gql';

interface CompanyUserIdResult {
  accountHolder?: CompanyUserQuery['viewer']['companyUsers'][0];
  loading: boolean;
  error?: ApolloError;
}

export const useAccountHolder = (): CompanyUserIdResult => {
  const { data, error, loading } = useQuery(CompanyUserDocument);
  const companyUsers = data?.viewer?.companyUsers || [];
  const accountHolder = companyUsers.find((user) =>
    user.roles.includes(Role.AccountHolder),
  );

  return {
    accountHolder,
    error,
    loading,
  };
};
